import {
  Button,
  Container,
  CssBaseline,
  Skeleton,
  Typography,
} from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import YouTube from 'react-youtube'
import { Header, SupportArchive } from '../../../components'
import lessons from '../../../services/lessons'

export default function PlayerPage() {
  const { id } = useParams()
  const { data: lesson, isLoading } = useQuery({
    queryFn: () => lessons.getByID(id),
    queryKey: [id],
  })

  const [watchedTime, setWatchedTime] = useState<number>(0)
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null)

  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 1, // Autoplay ativado
      modestbranding: 1, // Remove o logotipo do YouTube
      controls: 1, // Exibe os controles do player
    },
  }

  const onPlay = () => {
    if (!timer) {
      setTimer(
        setInterval(() => {
          setWatchedTime((prevTime) => prevTime + 1)
        }, 1000),
      )
    }
  }

  const onPause = () => {
    if (timer) {
      clearInterval(timer)
      setTimer(null)
    }
  }

  useEffect(() => {
    if (watchedTime >= 60) {
      if (lesson?.id && lesson.state !== 'Done') lessons.saveLog(lesson?.id)

      if (timer) {
        clearInterval(timer)
        setTimer(null)
      }
    }
  }, [lesson?.id, lesson?.state, timer, watchedTime])

  return (
    <Container component="main">
      <CssBaseline />
      <Header>
        <Typography variant="h2" sx={{ fontSize: 22, fontWeight: 600, ml: -4 }}>
          {lesson?.title}
        </Typography>
        <div />
      </Header>
      <div className="relative pb-[56.25%] overflow-hidden">
        {!isLoading && lesson?.video.url ? (
          <YouTube
            className="absolute top-0 left-0 right-0 bottom-0 rounded-lg"
            videoId={lesson?.video.url}
            onPlay={onPlay}
            onPause={onPause}
            opts={opts}
          />
        ) : (
          <Skeleton
            variant="rounded"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              width: '100%',
              height: '100%',
            }}
          />
        )}
      </div>
      <div>
        <div className="flex items-center justify-between mt-4">
          <h3 className="text-xl">Descrição</h3>

          <Button type="button" variant="contained" sx={{ minHeight: '90%' }}>
            <p className="text-sm normal-case">Fazer o Teste</p>
          </Button>
        </div>
        <p className="line-clamp-3 mt-2">{lesson?.description}</p>
        <h3 className="text-xl mt-4">Material de apoio</h3>

        <SupportArchive url="#" type="LINK" />
        <SupportArchive url="#" type="DOC" />
        <SupportArchive url="#" type="VIDEO" />
      </div>
    </Container>
  )
}
